import {
	CREATE_COMING_NEXT,
	CREATE_ONE_GURU_VERSION,
	CREATE_WHATS_NEW,
	DELETE_COMING_NEXT,
	DELETE_WHATS_NEW,
	GET_ALL_COMING_NEXT,
	GET_ALL_VERSION,
	GET_ALL_WHATS_NEW,
	GET_TARGET_QUARTERS,
	GET_WHATS_NEW_BY_ID,
	GET_WHATS_NEW_TYPES,
	UPDATE_COMING_NEXT,
	UPDATE_WHATS_NEW,
	UPLOAD_FILE,
} from '../config/api-url';
import { deleteRequest, getRequest, postRequest, putRequest } from '../config/auth';

export const getAllWhatsNewAPI = () => getRequest(`${GET_ALL_WHATS_NEW}`);
export const getAllComingNextAPI = () => getRequest(`${GET_ALL_COMING_NEXT}`);
export const getTargetQuartersAPI = () => getRequest(`${GET_TARGET_QUARTERS}`);
export const getAllVersionsAPI = () => getRequest(`${GET_ALL_VERSION}`);
export const createOneGuruVersionAPI = (data) => postRequest(`${CREATE_ONE_GURU_VERSION}`, data);
export const createComingNextAPI = (data) => postRequest(`${CREATE_COMING_NEXT}`, data);
export const updateComingNextAPI = (data) => putRequest(`${UPDATE_COMING_NEXT}`, data);
export const deleteComingNextAPI = (id) => deleteRequest(`${DELETE_COMING_NEXT}?oneGuruComingNextId=${id}`);
export const getWhatsNewTypesAPI = () => getRequest(`${GET_WHATS_NEW_TYPES}`);
export const createWhatsNewAPI = (data) => postRequest(`${CREATE_WHATS_NEW}`, data);
export const deleteWhatsNewAPI = (id) => deleteRequest(`${DELETE_WHATS_NEW}?whatsNewId=${id}`);
export const getWhatsNewByIdAPI = (id) => getRequest(`${GET_WHATS_NEW_BY_ID}/${id}`);
export const updateWhatsNewAPI = (data) => putRequest(`${UPDATE_WHATS_NEW}`, data);
export const uploadWhatsNewScreenshotAPI = (data) => postRequest(`${UPLOAD_FILE}`, data);
export const deleteWhatsNewScreenshotAPI = (documentId, documentModuleId) =>
	deleteRequest(`${UPLOAD_FILE}?featureId=${documentId}&featureListType=${documentModuleId}`);
